import ReactDOM from "react-dom/client";
import './assets/fonts/fonts.css';
import "./index.css";
import { Provider } from "react-redux";
import {persistor, store} from "./redux/store";
import { MainRouting } from "./routing/MainRouting/MainRouting";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { MainPage } from "./pages/MainPage/MainPage";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <MainPage />
    </PersistGate>
  </Provider>
);
